export default __webpack_public_path__ + "static/media/5.a804f324.jpg";